import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { InvoiceWithRelationsDto, ResponseDto } from "@mimber/schema"
import { invoicesKeys } from "../invoices.utils"

export const useInvoice = (
  uuid: string,
  options?: UseQueryOptions<ResponseDto<InvoiceWithRelationsDto>, Error>
): UseQueryResult<ResponseDto<InvoiceWithRelationsDto>, Error> => {
  guardAppUsage("mimber-organization", "useInvoice")

  const { server } = useServerContext()

  return useQuery({
    queryKey: invoicesKeys.findOne(uuid),
    queryFn: async () => {
      const response = await server.get<ResponseDto<InvoiceWithRelationsDto>>(
        `invoices/${uuid}`
      )
      return response.data
    },
    staleTime: 1 * 60 * 1000,
    enabled: !!uuid,
    ...options,
  })
}
